@if (open()) {
  <div class="sheet-backdrop" (click)="onBackdropClick($event)">
    <section
      #dialog
      class="bottom-sheet"
      role="dialog"
      aria-modal="true"
      tabindex="-1"
      aria-labelledby="sheet-title"
      [attr.aria-describedby]="description() ? 'sheet-description' : null"
      (keydown.escape)="close()"
    >
      <div class="sheet-grabber" aria-hidden="true"></div>

      <header class="sheet-header">
        <div>
          <h2 id="sheet-title">{{ title() }}</h2>
          @if (description()) {
            <p id="sheet-description">{{ description() }}</p>
          }
        </div>
        <button type="button" aria-label="Cerrar" (click)="close()">
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
      </header>

      <div class="sheet-body">
        <ng-content />
      </div>
    </section>
  </div>
}
